import React from 'react';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import useScrollTopOnMount from 'Hooks/useScrollTopOnMount';
import PropTypes from 'prop-types';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import RoundedButton from 'Components/ComponentLibrary/Components/Uncategorized/RoundedButton';

import PhoneIphoneIcon from 'Icons/IPhone';

import AccountSetupSection from '../../Components/AccountSetup/AccountSetupSection';
import SurveyFixedFooterActions from '../../../SurveyFixedFooterActions';
import { useSurveyStepContext } from '../../SurveyStepContext';

const styles = () => ({
  root: {},
  footer: {},
  enableButton: {},
});

const AccountSetupTwoFactorEnabledSuccessLayout = ({
  classes,
}) => {
  useScrollTopOnMount();
  const {
    onSubmit: onSubmitMetaForm,
  } = useMetaLayoutContext();

  const {
    onClickNext,
  } = useSurveyStepContext();

  return (
    <div className={classes.root}>
      {/* ---------- Section title / icon / message ---------- */}
      <AccountSetupSection
        icon={PhoneIphoneIcon}
        title={'Two-Factor Enabled!'}
        messages={[
          'Continue with your account setup.',
        ]}
      />

      {/* ---------- Footer (Continue) ---------- */}
      <SurveyFixedFooterActions>
        <RoundedButton
          className={classes.enableButton}
          onClick={() => onClickNext(onSubmitMetaForm)}
          color={'primary'}
          variant={'contained'}
          disableElevation
          fullWidth
          test={'two-factor-enabled-continue-button'}
        >
          {'Continue'}
        </RoundedButton>
      </SurveyFixedFooterActions>
    </div>
  );
};

AccountSetupTwoFactorEnabledSuccessLayout.propTypes = {
  classes: PropTypes.object.isRequired,
};

AccountSetupTwoFactorEnabledSuccessLayout.defaultProps = {
};

export default withStyles(styles)(AccountSetupTwoFactorEnabledSuccessLayout);
